import apiClient from '../apiClient';
import { PUT_REGION_URL } from '../apiUrl';

const putRegionApi = (id, data) => {
  return apiClient.put(PUT_REGION_URL(id), data);
};

export default putRegionApi;
